export default {
      id: "helicopter-usage",
      viewBox: "0 0 110 30",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#helicopter",
      toString: function () {
        return this.url;
      }
    }